import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import EducacaoService from '../../../../services/educacao';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [ano, setAno] = useState("");
    const [categoria, setCategoria] = useState("");
    const [referencia, setReferencia] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchDocumentos()
            setAno("")
            setCategoria("")
            setReferencia("")
        } else {
            var response = await EducacaoService.buscarDocs(query)
            if (response.data.length >= 1) {
                props.setDocumentos(response.data)
                props.setVazio(false)
                setAno("")
                setCategoria("")
                setReferencia("")
            } else {
                props.setVazio(true)
                setAno("")
                setCategoria("")
                setReferencia("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `ano=${ano}`;
        if (categoria !== "false" && categoria !== "") prepQuery = prepQuery + `&categoria=${encodeURI(categoria)}`;
        if (referencia !== "false" && referencia !== "") prepQuery = prepQuery + `&referencia=${encodeURI(referencia)}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={5}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        <option value="Parecer Conclusivo Conselho Municipal do FUNDEB sobre a Prestação de Contas">Parecer Conclusivo Conselho Municipal do FUNDEB</option>
                                        <option value="Ata do Conselho de Educação">Ata do Conselho de Educação</option>
                                        <option value="Ata do Conselho de Alimentação Escolar">Ata do Conselho de Alimentação Escolar</option>
                                        <option value="Plano Municipal de Educação">Plano Municipal de Educação</option>
                                        <option value="Relatório Anual da Gestão">Relatório Anual da Gestão</option>
                                        <option value="Cadastro Único da Creche Municipal">Cadastro Único da Creche Municipal</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={3}>
                            <Form.Group className="mb-3" controlId="Referência">
                                <FloatingLabel
                                    label="Referência"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Referência"
                                        name="referencia"
                                        onChange={e => setReferencia(e.target.value)}
                                    >
                                        <option>TODAS</option>
                                        <option value="1º Quadrimestre">1º Quadrimestre</option>
                                        <option value="2º Quadrimestre">2º Quadrimestre</option>
                                        <option value="3º Quadrimestre">3º Quadrimestre</option>
                                        <option value="2022-2025">2022-2025</option>
                                        <option value="2026-2029">2026-2029</option>
                                        <option value="Janeiro">Janeiro</option>
                                        <option value="Fevereiro">Fevereiro</option>
                                        <option value="Março">Março</option>
                                        <option value="Abril">Abril</option>
                                        <option value="Maio">Maio</option>
                                        <option value="Junho">Junho</option>
                                        <option value="Julho">Julho</option>
                                        <option value="Agosto">Agosto</option>
                                        <option value="Setembro">Setembro</option>
                                        <option value="Outubro">Outubro</option>
                                        <option value="Novembro">Novembro</option>
                                        <option value="Dezembro">Dezembro</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/educacao'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                     <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.documentos} nome={"DocumentosEducacao"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#f24df59c-9e05-4510-b7fb-de13b6c72e83" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca